import { CommonModule } from '@angular/common';
import { Component, NgModule, Input, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

import { LoginOauthModule } from 'src/app/components/library/login-oauth/login-oauth.component';
import { DxFormModule } from 'devextreme-angular/ui/form';
import { DxLoadIndicatorModule } from 'devextreme-angular/ui/load-indicator';
import { DxButtonModule, DxButtonTypes } from 'devextreme-angular/ui/button';
import notify from 'devextreme/ui/notify';
import { AuthService, IResponse, ThemeService } from 'src/app/services';

@Component({
	selector: 'app-login-form',
	templateUrl: './login-form.component.html',
	styleUrls: ['./login-form.component.scss'],
})
export class LoginFormComponent implements OnInit {
	@Input() resetLink = '/auth/reset-password';
	@Input() createAccountLink = '/auth/create-account';

	defaultAuthData: IResponse;

	btnStylingMode: DxButtonTypes.ButtonStyle;

	passwordMode = 'password';

	loading = false;

	formData: any = {};

	passwordEditorOptions = {
		placeholder: 'Jelszó',
		stylingMode:'filled',
		mode: this.passwordMode,
		value: '',
		// buttons: [{
		//   name: 'password',
		//   location: 'after',
		//   options: {
		//     icon: 'info',
		//     stylingMode:'text',
		//     onClick: () => this.changePasswordMode(),
		//   }
		// }]
	}

	constructor(private authService: AuthService, private router: Router, private themeService: ThemeService) {
		this.themeService.isDark.subscribe((value: boolean) => {
			this.btnStylingMode = value ? 'outlined' : 'contained';
		});
	}

	changePasswordMode() {
//		debugger;
		this.passwordMode = this.passwordMode === 'text' ? 'password' : 'text';
	};

	async onSubmit(e: Event) {
		e.preventDefault();
		const { email, password, rememberMe } = this.formData;
		this.loading = true;

		const result = await this.authService.logIn(email, password, null, rememberMe);
		this.loading = false;
		if (!result.isOk) {
			notify(result.message, 'error', 2000);
		}
	}

	onCreateAccountClick = () => {
		this.router.navigate([this.createAccountLink]);
	};

	async ngOnInit(): Promise<void> {
		this.defaultAuthData = await this.authService.getUser();
	}
}
@NgModule({
	imports: [
		CommonModule,
		RouterModule,
		LoginOauthModule,
		DxFormModule,
		DxLoadIndicatorModule,
		DxButtonModule
	],
	declarations: [LoginFormComponent],
	exports: [LoginFormComponent],
})
export class LoginFormModule { }
